import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CustomerEquipmentService } from '../../services/customer-equipment.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { ADD_CUSTOMER_EQUIPMENT_DIALOG } from 'src/testIds';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { TestIdDirective } from '../../directives/test-id.directive';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'app-add-customer-equipment-dialog',
    templateUrl: './add-customer-equipment-dialog.component.html',
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, ReactiveFormsModule, MatFormField, TestIdDirective, MatLabel, MatInput, MatDialogActions, MatButton, MatDialogClose]
})
export class AddCustomerEquipmentDialogComponent {
  testIds = ADD_CUSTOMER_EQUIPMENT_DIALOG;
  form = new FormGroup({
    name: new FormControl('', Validators.required),
    serial_number: new FormControl('')
  });

  constructor(
    private customerEquipmentService: CustomerEquipmentService,
    private dialog: MatDialogRef<AddCustomerEquipmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { customerId: number }
  ) {}

  save() {
    this.customerEquipmentService
      .add(this.data.customerId, {
        ...this.form.value,
        customer_id: this.data.customerId
      })
      .subscribe((equipment) => this.dialog.close(equipment));
  }
}
